var anObject = require('../internals/an-object');

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/iterator-close.js
// module id = 431
// module chunks = 1 2 3 4